import { jsx as n } from "react/jsx-runtime";
import { LinkIcon as u } from "../../icons/link-icon.mjs";
import { twMerge as p } from "tailwind-merge";
import { FormInput as c } from "./form-input.mjs";
import { useTranslation as x } from "../../i18n.mjs";
import { copyTextToClipboard as b } from "../../utils/copy-to-clipboard.mjs";
const N = ({
  onChange: o,
  value: e = "",
  addonBefore: a,
  withCopyButton: i,
  buttonClassName: l,
  linkIconClassName: m,
  scheme: r = "https://",
  ...s
}) => {
  const { t: f } = x(), d = e.replace(r, "");
  return /* @__PURE__ */ n(
    c,
    {
      type: "url",
      addonBefore: a || r,
      value: d,
      onChange: ({ target: { value: t } }) => {
        if (!t || t === r) return o("");
        o(r + t.replace(r, ""));
      },
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: i && /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          onClick: async (t) => {
            t.preventDefault(), await b(e, f);
          },
          className: p(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            l
          ),
          children: /* @__PURE__ */ n(
            u,
            {
              className: p(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                m
              )
            }
          )
        }
      ),
      ...s
    }
  );
};
export {
  N as FormInputUrl
};
